/* eslint-disable max-len */
import { Plugins } from '@leverege/plugin';
import NumericEqualsComparator from './NumericEqualsComparator.js';
import NumericEqualsComparatorEditor from "./NumericEqualsComparatorEditor.js";
import NumericEqualsComparatorEvaluator from './NumericEqualsComparatorEvaluator.js';
import NumericNotEqualsComparator from './NumericNotEqualsComparator.js';
import NumericNotEqualsComparatorEditor from "./NumericNotEqualsComparatorEditor.js";
import NumericNotEqualsComparatorEvaluator from './NumericNotEqualsComparatorEvaluator.js';
import NumericLessThanComparator from './NumericLessThanComparator.js';
import NumericLessThanComparatorEditor from "./NumericLessThanComparatorEditor.js";
import NumericLessThanComparatorEvaluator from './NumericLessThanComparatorEvaluator.js';
import NumericGreaterThanComparator from './NumericGreaterThanComparator.js';
import NumericGreaterThanComparatorEditor from "./NumericGreaterThanComparatorEditor.js";
import NumericGreaterThanComparatorEvaluator from './NumericGreaterThanComparatorEvaluator.js';
import NumericBetweenComparator from './NumericBetweenComparator.js';
import NumericBetweenComparatorEditor from "./NumericBetweenComparatorEditor.js";
import NumericBetweenComparatorEvaluator from './NumericBetweenComparatorEvaluator.js';
import NumericGreaterThanOrEqualComparator from './NumericGreaterThanOrEqualComparator.js';
import NumericGreaterThanOrEqualComparatorEditor from "./NumericGreaterThanOrEqualComparatorEditor.js";
import NumericGreaterThanOrEqualComparatorEvaluator from './NumericGreaterThanOrEqualComparatorEvaluator.js';
import NumericLessThanOrEqualComparator from './NumericLessThanOrEqualComparator.js';
import NumericLessThanOrEqualComparatorEditor from "./NumericLessThanOrEqualComparatorEditor.js";
import NumericLessThanOrEqualComparatorEvaluator from './NumericLessThanOrEqualComparatorEvaluator.js';
import TimestampBetweenComparator from './TimestampBetweenComparator.js';
import TimestampGreaterThanComparator from './TimestampGreaterThanComparator.js';
import TimestampGreaterThanOrEqualComparator from './TimestampGreaterThanOrEqualComparator.js';
import TimestampLessThanComparator from './TimestampLessThanComparator.js';
import TimestampLessThanOrEqualComparator from './TimestampLessThanOrEqualComparator.js';
export default {
  install(opts) {
    Plugins.add('AttributeConditionComparator', NumericEqualsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericEqualsComparator.TYPE,
      editor: NumericEqualsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericEqualsComparator.TYPE,
      evaluator: NumericEqualsComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericNotEqualsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericNotEqualsComparator.TYPE,
      editor: NumericNotEqualsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericNotEqualsComparator.TYPE,
      evaluator: NumericNotEqualsComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericLessThanComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericLessThanComparator.TYPE,
      editor: NumericLessThanComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericLessThanComparator.TYPE,
      evaluator: NumericLessThanComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', TimestampLessThanComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: TimestampLessThanComparator.TYPE,
      editor: NumericLessThanComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: TimestampLessThanComparator.TYPE,
      evaluator: NumericLessThanComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericLessThanOrEqualComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericLessThanOrEqualComparator.TYPE,
      editor: NumericLessThanOrEqualComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericLessThanOrEqualComparator.TYPE,
      evaluator: NumericLessThanOrEqualComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', TimestampLessThanOrEqualComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: TimestampLessThanOrEqualComparator.TYPE,
      editor: NumericLessThanOrEqualComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: TimestampLessThanOrEqualComparator.TYPE,
      evaluator: NumericLessThanOrEqualComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericGreaterThanComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericGreaterThanComparator.TYPE,
      editor: NumericGreaterThanComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericGreaterThanComparator.TYPE,
      evaluator: NumericGreaterThanComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', TimestampGreaterThanComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: TimestampGreaterThanComparator.TYPE,
      editor: NumericGreaterThanComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: TimestampGreaterThanComparator.TYPE,
      evaluator: NumericGreaterThanComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericGreaterThanOrEqualComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericGreaterThanOrEqualComparator.TYPE,
      editor: NumericGreaterThanOrEqualComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericGreaterThanOrEqualComparator.TYPE,
      evaluator: NumericGreaterThanOrEqualComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', TimestampGreaterThanOrEqualComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: TimestampGreaterThanOrEqualComparator.TYPE,
      editor: NumericGreaterThanOrEqualComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: TimestampGreaterThanOrEqualComparator.TYPE,
      evaluator: NumericGreaterThanOrEqualComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', NumericBetweenComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: NumericBetweenComparator.TYPE,
      editor: NumericBetweenComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: NumericBetweenComparator.TYPE,
      evaluator: NumericBetweenComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', TimestampBetweenComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: TimestampBetweenComparator.TYPE,
      editor: NumericBetweenComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: TimestampBetweenComparator.TYPE,
      evaluator: NumericBetweenComparatorEvaluator
    });
  }
};